namespace GeniuzPOS.SalePromoCamp {
    export interface PsPromoActiveHdRow {
        PromoId?: string;
        PromoName?: string;
        PromoDesc?: string;
        PromoCampaign?: string;
        StartPromoDate?: string;
        EndPromoDate?: string;
        PromoTimeFg?: PromoTimeFg;
        StartPromoTime?: string;
        EndPromoTime?: string;
        PromoDayFg?: PromoDayChFg;
        PromoDay?: number[];
        PromoShopFg?: PromoShopFg;
        PromoShop?: string[];
        PromoCustFg?: number;
        PromoMb?: string[];
        PromoApproveFg?: ApprovePromoFgSelect;
        PromoStatus?: PostStatus;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        ApproveBy?: string;
        Approvedate?: string;
        ActiveBy?: string;
        Activedate?: string;
        Id?: number;
        PromoApDetailList?: PsPromoApDtRow[];
        VenderSharing?: number;
    }

    export namespace PsPromoActiveHdRow {
        export const idProperty = 'PromoId';
        export const nameProperty = 'PromoId';
        export const localTextPrefix = 'SalePromoCamp.PsPromoActiveHd';
        export const lookupKey = 'SalePromoCamp.PsPromoActiveHd';

        export function getLookup(): Q.Lookup<PsPromoActiveHdRow> {
            return Q.getLookup<PsPromoActiveHdRow>('SalePromoCamp.PsPromoActiveHd');
        }
        export const deletePermission = '1POSBASE:การจัดการราคาโปรโมชั่น:Active:Modify';
        export const insertPermission = '1POSBASE:การจัดการราคาโปรโมชั่น:Active:Modify';
        export const readPermission = '1POSBASE:การจัดการราคาโปรโมชั่น:Active:View';
        export const updatePermission = '1POSBASE:การจัดการราคาโปรโมชั่น:Active:Modify';

        export declare const enum Fields {
            PromoId = "PromoId",
            PromoName = "PromoName",
            PromoDesc = "PromoDesc",
            PromoCampaign = "PromoCampaign",
            StartPromoDate = "StartPromoDate",
            EndPromoDate = "EndPromoDate",
            PromoTimeFg = "PromoTimeFg",
            StartPromoTime = "StartPromoTime",
            EndPromoTime = "EndPromoTime",
            PromoDayFg = "PromoDayFg",
            PromoDay = "PromoDay",
            PromoShopFg = "PromoShopFg",
            PromoShop = "PromoShop",
            PromoCustFg = "PromoCustFg",
            PromoMb = "PromoMb",
            PromoApproveFg = "PromoApproveFg",
            PromoStatus = "PromoStatus",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            ApproveBy = "ApproveBy",
            Approvedate = "Approvedate",
            ActiveBy = "ActiveBy",
            Activedate = "Activedate",
            Id = "Id",
            PromoApDetailList = "PromoApDetailList",
            VenderSharing = "VenderSharing"
        }
    }
}
